import { render } from "./add-vendor.vue?vue&type=template&id=1e54747b"
import script from "./add-vendor.vue?vue&type=script&lang=js"
export * from "./add-vendor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__